// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';

import Modal from './Modal';

export default class CreateScript extends Modal {

    state = {
        name: "",
        alert: false
    }

    createScript = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ alert: false });
        if (this.state.name.length < 10) {
            this.setState({ alert: true });
            return toast.error("Script name must be at least 10 characters long.");
        }
        this.props.createScript(this.state.name);
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <div style={{
                height: 150
            }} />

            <h1>Create a new <strong>script</strong></h1>

            <p>Scripts in Stax·ai allow you to automatically run code on a scheduled basis. This can be used to run scripts to feed data into Stax·ai, frequently check or update document fields, etc.</p>

            <br />

            <form onSubmit={this.createScript}>

                <input
                    id="scriptname"
                    name="scriptname"
                    type="text"
                    className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                    placeholder="Enter new script name..."
                    style={{width: 330 }}
                    value={this.state.name}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ name: e.target.value, alert: false })}
                />

                <input
                    type="submit"
                    value="Create"
                    className="input-inline-submit"
                />
            
            </form>
            
        </div>);
    }

};